export default __webpack_public_path__ + "static/media/Conversation_about_reusable_and_plastic_dishes_ENG.e841c6e1.mp4";